// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/PrivacyAndTerms/style.css
// module id = 3773
// module chunks = 33